import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/_auth')({
  beforeLoad: async ({ context }) => {
    const { isAuthenticated } = context;

    if (isAuthenticated) {
      throw redirect({ to: '/dashboard' });
    }
  },
});
